import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {
    IRecommendationsResponse,
    IGetProductRecommendationsProps,
    IGetRecommendationsProps,
} from 'modules/recommendations/types';
import {IGetProductRecommendationsResponse} from 'modules/home/types';

const ENDPOINT_PRODUCT_RECOMMENDATIONS = '/catalog/product/recommendations';
const ENDPOINT_RECOMMENDATIONS = '/recommendations';

export const recommendationsApiService = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getProductRecommendations: builder.query<IGetProductRecommendationsResponse, IGetProductRecommendationsProps>({
            query: ({data}) => {
                return {
                    body: {
                        ...data,
                        filter: {...data.filter, article: data.filter.id},
                    },
                    method: 'POST',
                    url: `${API_VERSION}${ENDPOINT_PRODUCT_RECOMMENDATIONS}`,
                };
            },
            serializeQueryArgs: (args) => args.queryArgs.data.filter.id,
            providesTags: ['Product/Recommendations'],
        }),
        getRecommendations: builder.query<IRecommendationsResponse, IGetRecommendationsProps>({
            query: (data) => {
                return {
                    body: data,
                    method: 'POST',
                    url: `${API_VERSION}${ENDPOINT_RECOMMENDATIONS}`,
                };
            },
            serializeQueryArgs: (args) => JSON.stringify(args.queryArgs.data),
            providesTags: ['Product/Recommendations'],
        }),
    }),
});

export const {useGetProductRecommendationsQuery, useGetRecommendationsQuery} = recommendationsApiService;
